<script setup lang="ts">
import { HiddenField } from "@formwerk/core";

defineProps<{ productId: number }>();
const { result, isSubmitting, onSubmit } = useAddGiftCardForm();
const deliveryDate = ref(new Date());
</script>

<template>
  <UiFormWrapper :result="result" @submit="onSubmit">
    <HiddenField name="product_id" :value="productId" />
    <FieldNumber name="amount" label="Montant" :min="15" :step="0.01" required>
      <template #suffix>
        <span class="i-lucide-dollar-sign size-6 text-muted" />
      </template>
    </FieldNumber>
    <FieldDatePicker v-model="deliveryDate" name="delivery_date" label="Date d'envoi" :min="new Date()" required />
    <FieldText name="recipient_name" type="text" label="Nom du destinataire" required />
    <FieldText name="recipient_email" type="email" label="Courriel du destinataire" required />
    <FieldTextarea name="message" label="Message" required />
    <UiSubmitButton :is-submitting="isSubmitting">
      Ajouter au panier
    </UiSubmitButton>
  </UiFormWrapper>
</template>
